import { fallbackLng, supportedLanguages } from "@/i18n/config"

function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

const localePattern = supportedLanguages
  .map(({ locale }) => escapeRegex(locale))
  .sort((a, b) => b.length - a.length)
  .join("|")

const localePrefixRegex = new RegExp(`^/(?:${localePattern})(?=/|$)`)

export function detectLocaleFromPathname(pathname: string): string {
  const normalizedPath = pathname || "/"
  const match = normalizedPath.match(new RegExp(`^/(${localePattern})(?=/|$)`))
  return match?.[1] || fallbackLng
}

export function stripLocalePrefix(pathname: string): string {
  const normalizedPath = pathname || "/"
  return normalizedPath.replace(localePrefixRegex, "") || "/"
}

export function localizePathname(pathname: string, targetLocale: string): string {
  const pathWithoutLocale = stripLocalePrefix(pathname)

  return pathWithoutLocale === "/"
    ? `/${targetLocale}`
    : `/${targetLocale}${pathWithoutLocale}`
}
